import lowResolutionBg from './assets/bg-low-resolution-placeholder.png';
import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const lowResolutionPlaceholder = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: 50px;
  box-sizing: border-box;
  background: url(${lowResolutionBg}) no-repeat center center;
  background-size: cover;

  svg {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
    color: ${colors.white};
  }

  span {
    color: ${colors.white};
  }

  button {
    margin-top: 20px;
  }
`;

export default {
  lowResolutionPlaceholder,
};
